import {Component, Input, QueryList, ViewChildren} from '@angular/core';
import {OrganizationConstant} from '@models/adminstration/organization/constants/organization-constant';
import {OrganizationConstantValue} from '@models/adminstration/organization/constants/organization-constant-value';
import {ConstantsService} from '@services/administration/organization/configuration/constants/constants.service';
import {PortalGeneralSetting} from '@models/adminstration/organization/constants/portal-general-setting';
import {
  SortEvent,
  TableHeaderSortableDirective
} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '@services/notification/notification.service';
import {ConstantModalComponent} from '@components/administration/organization/configuration/constants/constant-modal/constant-modal.component';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-admin-organization-constant',
    templateUrl: './constant.component.html',
    styleUrls: ['./constant.component.scss'],
    standalone: false
})
export class ConstantComponent {

  @Input()
  constants: OrganizationConstant[] = new Array<OrganizationConstant>();
  @Input()
  portalSettings: PortalGeneralSetting[] = new Array<PortalGeneralSetting>();
  @Input()
  isAdminRole: boolean = false;
  @Input()
  isSuperAdminRole: boolean = false;
  @Input()
  organizationId: number = -1;
  @Input()
  organizationName: string = '';

  dateTimeFormat: string = 'dd.MM.yyyy';
  private COMPONENT_NAME: string = 'ConstantComponent';

  constructor(private modalService: ModalService,
              private loadingIndicator: LoadingIndicatorService,
              public translate: TranslateService,
              private notification: NotificationService,
              private constantsService: ConstantsService,
              private tableHeaderSortableService: TableHeaderSortableService) {
  }

  onAddConstant() {
    const modalRef = this.modalService.open(ConstantModalComponent, {size: 'lg'});
    modalRef.componentInstance.portalSettings = this.portalSettings;
    modalRef.componentInstance.constant = new OrganizationConstant();
    modalRef.componentInstance.constants = this.constants;
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.result.then((result) => {
      this.loadingIndicator.show(this.translate.instant('Adding organization constant'));
      this.constantsService.saveConstant(this.organizationId, result).subscribe((success) => {
        const message = this.translate.instant('Organization constant saved.');
        this.constants.push(success);
        this.notification.success(message, this.COMPONENT_NAME, false);
        this.loadingIndicator.hide();
      }, (error) => {
        this.notification.error(this.translate.instant('Error saving organization constant'),
            error, this.COMPONENT_NAME, true);
        this.loadingIndicator.hide();
      });
    });
  }

  isActiveInterval(valueItem: OrganizationConstantValue) {
    return this.constantsService.constantIntervalIsActive(valueItem);
  }

  intervalIsInPast(valueItem: OrganizationConstantValue) {
    return this.constantsService.constantIntervalIsInPast(valueItem);
  }

  //SORTING
  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.constants = this.tableHeaderSortableService.sortItems<OrganizationConstant>(this.constants, column, direction);
  }
}
